import React from 'react';
import { connect } from 'react-redux';

import Icon from './../Icon';
import Dropdown from './../Dropdown';
import Select from './../Select';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'profile_cellphoneos';
const options = ['Not specified', 'iOS', 'Android', 'Both', 'Other'];

const CellOsDropdown = props => {
    const { value, save } = props;
    const text = value || 'Select';
    return (
        <div>
            Cell phone OS:
            <Dropdown buttonClassName="lnk-dropdown" text={text} closeAlways>
                <Select value={value} onChange={save} className="menu menu-selectable">
                    {options.map(option =>
                        <li key={option} value={option.toLowerCase()} className="menu-item">{option}
                            <Icon className="svg-icon" iconName="check-empty" />
                        </li>
                    )}
                </Select>
            </Dropdown>
        </div>
    );
};

const mapStateToProps = state => ({
    value: state.user[fieldName] || options[0]
});
const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value.toLowerCase()))
});

export default connect(mapStateToProps, mapDispatchToProps)(CellOsDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/CellOsDropdown.js